import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { resetState } from './reset-state/reset-state-reducer';
import { allReducers } from 'state/allSlices';
import { preventMaxAttemptErrorResetMiddleware } from 'state/direct-debit/direct-debit-slice';

import type { Reducers } from 'state/allSlices.generated';

const rootReducer = combineReducers<Reducers>(allReducers);

//for reset reducer; to be removed if not use it
const resetReducer = (state, action) => {
  state = resetState(state, action);

  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resetReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(
      preventMaxAttemptErrorResetMiddleware.middleware
    )
});

export type AppStore = typeof store;
// Infer the `RootState`,  `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];
